import React from "react";

import styles from "./HomePage.module.scss";
import NarwhalGroup from "../../NarwhalGroup";
import cn from "classnames";
import DatesTable from "../../DatesTable/DatesTable";
import InfoTable from "../../DatesTable/InfoTable";
import UniLogo from "../../icons/UniLogo";
import EthnologyAssociationLogo from "../../icons/EthnologyAssociationLogo";
import ArniLogo from "../../icons/ArniLogo";
import NationalMuseumLogo from "../../icons/NationalMuseumLogo";
import ArtMuseumLogo from "../../icons/ArtMuseumLogo";
import NationalGalleryLogo from "../../icons/NationalGalleryLogo";
import CityMuseumLogo from "../../icons/CityMuseumLogo";
import IsfnrLogo from "../../icons/IsfnrLogo";

const HomePage = () => {
  return (
    <div className={styles.wrapper}>
      <div className={cn(styles.section, styles.firstSectionWrapper)}>
        <div className={styles.firstSection}>
          <div className={styles.text}>
            <h1 className={styles.header}>Nature(s) in Narrative</h1>
            <p className={styles.text}>
              {`The ISFNR Interim conference in 2026 was held in Reykjavík Iceland, June 13th to 16th.

        The conference welcomed 430 in person and 120 online delegates from 46 countries.

        The conference took place at the main campus of the University of Iceland, a walking distance from the vibrant city centre of Reykjavík.

        The conference was hosted by the department of Folkloristics at the University of Iceland, the Icelandic Association of Ethnology and Folklore and The Árni Magnússon Institute for Icelandic Studies.

        This was a hybrid event, so delegates were be able to participate either virtually or in person.

        Thank you for joining us in Reykjavík!`}
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
            >
              <a
                href="https://nomadit.co.uk/conference/isfnr2026/timetable"
                className={styles.downloadLink}
              >
                Programme
              </a>
            </div>

            {/* <div>
              <InfoTable />
            </div>

            <div>
              <DatesTable />
            </div> */}
          </div>

          <div>
            <div className={styles.narwhal}>
              <NarwhalGroup />
              {/* <LogoLeftAligned /> */}
              {/* <Logo1 /> */}
            </div>
          </div>
        </div>

        <hr className={styles.divider} />

        <div className={styles.themeSection}>
          <h2 className={styles.header}>Conference Theme</h2>
          <p className={styles.text}>
            The conference engaged broadly with the theme of nature(s) in
            narrative. We asked how narrative is entangled with nature in its
            various forms, situated in the micro and macro, the rural and urban,
            ranging from essentialist notions of the natural, the supernatural
            to non-binary assemblages of nature-culture. Subjects for discussion
            included the following:
          </p>

          <ul className={styles.list}>
            <li>
              How do notions of nature relate to narrations of identity,
              heritage, the national and personal, the physical and the
              spiritual?
            </li>
            <li>
              What comprehensions of “the natural” can be gleaned from
              storytelling, in its various cultural and social contexts, and in
              folk narrative research itself?
            </li>
            <li>
              How has our narrative vocabulary and academic terminology borrowed
              from and conversed with the discourses of nature?
            </li>
            <li>Does folk narrative entail a commons of sorts?</li>
            <li>
              How do environment and disparate nature-cultural assemblages shape
              narrative, characters, flow, style and storytelling events?
            </li>
            <li>
              How are human and non-human entanglements expressed, sensed,
              performed and reimagined in storytelling events?
            </li>
            <li>
              How do narrators delineate “selves” from “the other” in the living
              world; the natural from the “unnatural” or supernatural; the
              mundane from the enchanted?
            </li>
            <li>
              How are our conceptions of nature shaped and challenged by unusual
              “natural events” and climate crises, or urbanisation, technology,
              information disorder (fake news) and artificial intelligence?
            </li>
            <li>
              What are the “natures” of archives and how are they shaped by
              narratives?
            </li>
            <li>
              Do natures in narrative reveal aspects of the “natures” of
              narrative, its forms, functions and practice?
            </li>
          </ul>
        </div>

        <hr className={styles.divider} />

        <div className={styles.themeSection}>
          <section className={styles.page}>
            <div className={styles.hero}>
              <h1>Organisers & Committees</h1>
              <p>ISFNR 2026 • Reykjavík, Iceland</p>
            </div>

            <div className={styles.institutions}>
              <h2>Host Institutions</h2>

              <p className={styles.text}>
                Department of Folkloristics/ethnology at the University of
                Iceland, the Icelandic Association of Ethnology and Folklore,
                and The Árni Magnússon Institute for Icelandic Studies
              </p>

              <div className={styles.logoGrid}>
                <div className={cn(styles.ethnologyLogo, styles.logo)}>
                  <EthnologyAssociationLogo />
                </div>
                <div className={cn(styles.uniLogo, styles.logo)}>
                  <UniLogo className={styles.logo} />
                </div>
                <div className={cn(styles.arniLogo, styles.logo)}>
                  <ArniLogo className={styles.logo} />
                </div>
              </div>
            </div>

            <div className={styles.institutions}>
              <h2>Organising Institutions</h2>

              {/* <div className={styles.logoGrid}>
          <img src={uniLogo} alt="University of Iceland" />
          <img src={assocLogo} alt="Icelandic Folklore Association" />
          <img src={arniLogo} alt="Arni Magnusson Institute" />
          <img src={isfnrLogo} alt="ISFNR" />
        </div> */}
              <p className={styles.text}>
                Department of Folkloristics/Ethnology at the University of
                Iceland, the Icelandic Association of Ethnology and Folklore,
                and The Árni Magnússon Institute for Icelandic Studies.
              </p>

              <div>
                <p className={styles.text}>
                  ISFNR – The International Society For Folk Narrative Research.
                </p>
                <div className={styles.isfnrLogo}>
                  <IsfnrLogo />
                </div>
              </div>
            </div>

            <div className={styles.committees}>
              <div className={styles.committeeBlock}>
                <h3>Local Organising Committee</h3>
                <ul>
                  <li>
                    Dagrún Ósk Jónsdóttir – University of Iceland / Icelandic
                    Association of Ethnology and Folklore
                  </li>
                  <li>Kristinn Schram – University of Iceland</li>
                  <li>Rósa Þorsteinsdóttir – Árni Magnússon Institute</li>
                </ul>
              </div>

              <div className={styles.committeeBlock}>
                <h3>Academic Committee</h3>
                <ul>
                  <li>Eva Þórdís Ebenezersdóttir – University of Iceland</li>
                  <li>Felix Lummer – University of Iceland</li>
                  <li>Júlíana Þóra Magnúsdóttir – University of Iceland</li>
                  <li>Kristinn Schram – University of Iceland</li>
                  <li>
                    Dagrún Ósk Jónsdóttir – University of Iceland / Icelandic
                    Association of Ethnology and Folklore
                  </li>
                </ul>
              </div>
            </div>

            <div className={styles.institutions}>
              <h2>Local Collaborators</h2>

              <p className={styles.text}>
                The National Museum, The Reykjavík art museum, The National
                Gallery and The City Museum
              </p>

              <div className={styles.logoGrid}>
                <div className={cn(styles.nationalMuseum, styles.logo)}>
                  <NationalMuseumLogo />
                </div>
                <div className={cn(styles.artMuseum, styles.logo)}>
                  <ArtMuseumLogo />
                </div>
                <div className={cn(styles.nationalGallery, styles.logo)}>
                  <NationalGalleryLogo className={styles.logo} />
                </div>
                <div className={cn(styles.cityMuseum, styles.logo)}>
                  <CityMuseumLogo className={styles.logo} />
                </div>
              </div>
            </div>

            <div className={styles.adminBlock}>
              <h3>Conference Administration</h3>
              <p>NomadIT</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
